/*
    Calculator.js
    utilitaires pour les calculettes LPI rachetées
*/


function format(valeur, decimal, separateur) {
  var deci = Math.round(Math.pow(10, decimal) * (Math.abs(valeur) - Math.floor(Math.abs(valeur))));
  var val = Math.floor(Math.abs(valeur));
  if ((decimal == 0) || (deci == Math.pow(10, decimal))) {
    val = Math.floor(Math.abs(valeur));
    deci = 0;
  }
  var val_format = val + "";
  var nb = val_format.length;
  for (var i = 1; i < 4; i++) {
    if (val >= Math.pow(10, (3 * i))) {
      val_format = val_format.substring(0, nb - (3 * i)) + separateur + val_format.substring(nb - (3 * i));
    }
  }
  if (decimal > 0) {
    var decim = "";
    for (var j = 0; j < (decimal - deci.toString().length); j++) {
      decim += "0";
    }
    deci = decim + deci.toString();
    val_format = val_format + "." + deci;
  }
  if (parseFloat(valeur) < 0) {
    val_format = "-" + val_format;
  }
  return val_format;
}

function formatFloat(valeur, separateur) {
  valeur = valeur.replace(' ', ''); // suppression des espaces
  if (separateur == ".")
    return valeur.replace(/,/g, "\.");
  else
    return valeur.replace(/\./g, ",");
}

function empty(mixed_var) {
  var key;
  if (mixed_var === "" || mixed_var === 0 || mixed_var === "0" || mixed_var === null || mixed_var === false || mixed_var === undefined) {
    return true;
  }
  if (typeof mixed_var == 'object') {
    for (key in mixed_var) {
      return false;
    }
    return true;
  }
  return false;
}

function join(glue, pieces) {
  return ((pieces instanceof Array) ? pieces.join(glue) : pieces);
}

function http_build_query(formdata, numeric_prefix, arg_separator) {
  var key, use_val, use_key, i = 0,
    j = 0,
    tmp_arr = [];
  if (!arg_separator) {
    arg_separator = '&';
  }
  for (key in formdata) {
    use_val = urlencode(formdata[key].toString());
    use_key = urlencode(key);
    if (numeric_prefix && !isNaN(key)) {
      use_key = numeric_prefix + j;
      j++;
    }
    tmp_arr[i++] = use_key + '=' + use_val;
  }
  return tmp_arr.join(arg_separator);
}

function urlencode(str) {
  var histogram = {},
    tmp_arr = [];
  var ret = str.toString();
  var replacer = function(search, replace, str) {
    var tmp_arr = [];
    tmp_arr = str.split(search);
    return tmp_arr.join(replace);
  };
  histogram["'"] = '%27';
  histogram['('] = '%28';
  histogram[')'] = '%29';
  histogram['*'] = '%2A';
  histogram['~'] = '%7E';
  histogram['!'] = '%21';
  histogram['%20'] = '+';
  ret = encodeURIComponent(ret);
  for (search in histogram) {
    replace = histogram[search];
    ret = replacer(search, replace, ret)
  }
  return ret.replace(/(\%([a-z0-9]{2}))/g, function(full, m1, m2) {
    return "%" + m2.toUpperCase();
  });
  return ret;
}

function toggle(id) {
  var element = document.getElementById(id);
  if (typeof(element) != "undefined") {
    if (element.style.display == "")
      element.style.display = "none";
    else
      element.style.display = "";
  }
}

function show(id) {
  jQuery('#' + id).show();
}

function hide(id) {
  jQuery('#' + id).hide();
}

/*
    Fonctions de calcul des taux en fonction du CP
*/
/*
    ICI : première version de pré-remplissage des taux
    -->

$(document).ready(function() {
  $('.calc-taux-js').focus(function() {
    $(this).data('lockAuto', true);
  })
  $('.calc-cpTaux-js').change(function() {
    var cp = $(this).val();
    if(!cp.match(/^(\d ?){5}$/)) return false;

    var $form = $(this).parents('.sfi-calc--form__content');
    var duree = $('.calc-duree-js', $form).val();
    var autoTaux = !$('.calc-taux-js', $form).data('lockAuto');

    if(autoTaux) calc_getTauxByCP($form, cp, duree );
  })
});

function calc_getTauxByCP($form, cp, duree, qualite) {
  var $formulaire = $form;
  var data = {
    'action':   'lpi_taux_by_cp',
    'cp' : cp
  };
  if(duree) data.duree = duree;
  if(qualite) data.qualite = qualite;

  $.ajax({
    'url': env_data.ajaxurl,
    'data' : data,
    'dataType': 'json',
    success: function(data, textStatus, xhr) {
      console.log(data);
      $('.calc-taux-js', $formulaire).val(data[0].rate);
    }
  });
}
*/
